import React from "react";
import style from "./index.module.scss";
import { Link } from "react-router-dom";
const App = (props) => {
  let { title, subtitle, bg, titlebg, getData } = props;
  return (
    <div
      className={style.caseContainer}
      style={{ background: `url(${bg}) no-repeat`, backgroundSize: "cover" }}
    >
      <div className={`${style.content}`}>
        <div className={`${style.list}`}>
          <div
            className={`${style.left}`}
            style={{
              background: `url(${titlebg}) no-repeat`,
              backgroundSize: "cover",
            }}
          >
            <div className={`${style.title}`}>
              <i></i>
              <span>{title}</span>
              <i></i>
            </div>
            <div className={`${style.subtitle}`}>
              <span>{subtitle}</span>
            </div>
          </div>
          {getData.data &&
            getData.data.data.map((item, index) => (
              <div key={index} className={`${style.listItem}`}>
                <i
                  style={{
                    background: `url(${item.icon}) no-repeat`,
                    backgroundSize: "cover",
                  }}
                ></i>
                <div className={`${style.itemTitle}`}>{item.title}</div>
                <div className={`${style.itemSubtitle}`}>{item.subtitle}</div>
                <div className={`${style.itemMore}`}>
                  <Link to={item.link} clstag={item.clstag}>
                    了解更多<i></i>
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default App;
